import type { TranslationTree } from '../../types';

export const contact: TranslationTree = {
  contact: {
    intro: {
      badge: 'Kontakt',
      title: 'Das ToolLife-Team kontaktieren',
      description:
        'Füllen Sie das Formular aus, um eine vorausgefüllte E-Mail in Ihrem E-Mail-Client zu öffnen.',
      highlights: {
        question: {
          title: 'Eine Frage stellen',
          description:
            'Beschreiben Sie Ihr Anliegen — wir lesen Ihre Nachricht und antworten per E-Mail.',
        },
        bug: {
          title: 'Fehler melden',
          description: 'Geben Sie das betroffene Modul und die Reproduktionsschritte an.',
        },
        followUp: {
          title: 'Verbesserungsvorschlag',
          description:
            'Teilen Sie Ideen zur Verbesserung der App oder schlagen Sie neue Funktionen vor.',
        },
      },
    },
    form: {
      badge: 'Kontaktformular',
      title: 'Nachricht senden',
      description:
        'Füllen Sie die Felder unten aus — beim Klick auf Senden öffnet sich Ihr E-Mail-Client mit der fertigen Nachricht.',
      contactInfo: {
        title: 'Direkte Adresse',
        copyCta: 'Adresse kopieren',
        copySuccess: 'Adresse kopiert!',
        copyError: 'Kopieren auf diesem Gerät nicht möglich.',
      },
      fields: {
        subjectLabel: 'Betreff',
        subjectPlaceholder: 'z.B. Scanner-Synchronisationsproblem',
        categoryLabel: 'Anfragetyp',
        categoryPlaceholder: 'Auswählen',
        messageLabel: 'Nachricht',
        messagePlaceholder:
          'Beschreiben Sie Ihre Frage oder den aufgetretenen Fehler mit den Reproduktionsschritten, falls möglich.',
      },
      categories: {
        bug: 'Fehler oder Anomalie',
        question: 'Nutzungsfrage',
        improvement: 'Verbesserungsvorschlag',
        other: 'Andere',
        fallback: 'Anfrage',
      },
      copy: {
        notAvailable: 'Kopieren auf diesem Gerät nicht verfügbar.',
      },
      emailFallback: 'Adresse nicht angegeben',
      mail: {
        subject: '{{category}} - {{subject}}',
        body: 'Anfragetyp: {{category}}\n---\nAbsender: {{author}}\n---\n{{message}}\n',
      },
      status: {
        successTitle: 'Ihr E-Mail-Client wurde geöffnet.',
        successDescription:
          'Denken Sie daran, den Inhalt vor dem Senden zu überprüfen und bei Bedarf Screenshots hinzuzufügen.',
        errorDefault: 'E-Mail-Client konnte nicht geöffnet werden.',
        opening: 'Wird geöffnet…',
      },
      actions: {
        openClient: 'Meinen E-Mail-Client öffnen',
        reset: 'Formular zurücksetzen',
        back: 'Zurück',
      },
    },
  },
};
